import type { FC } from 'react';
import { useEffect } from 'react';

import {
  useExitIntentTracking,
  useTracking,
} from '@xing-com/crate-communication-tracking';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useExperiment } from '@xing-com/hub';

export type PageViewTrackerProps = {
  page?: string;
  sentBy?: string;
};

export const PageViewTracker: FC<PageViewTrackerProps> = ({ page, sentBy }) => {
  const { isLoggedOut } = useLoginState();
  const isExitIntentExperimentEnabled = useExperiment('ABACUS-560') === 'B';
  const { track } = useTracking();
  useExitIntentTracking({
    enabled: isLoggedOut && isExitIntentExperimentEnabled,
    page,
  });

  useEffect(() => {
    if (page && sentBy) {
      track({
        type: 'nwt',
        event: 'viewed_screen',
        eventSchema: 'basic',
        page,
        sentBy,
      });
    }
  }, [page, sentBy, track]);

  return <></>;
};
